import {createContext} from 'react'

 const CollapseContext = createContext(false);

 export default CollapseContext;